
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";

interface OnboardingFormProps {
  defaultEmail?: string;
  onSubmit?: (data: { name: string; email: string }) => void;
}

const OnboardingForm: React.FC<OnboardingFormProps> = ({ defaultEmail = '', onSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState(defaultEmail);
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Here you would call your Supabase insert.
    setTimeout(() => {
      setIsSubmitting(false);
      toast({
        title: "Success",
        description: "Your information has been saved.",
      });
      if (onSubmit) onSubmit({ name, email });
    }, 1000);
  };

  return (
    <form className="space-y-4 mt-8" onSubmit={handleSubmit}>
      <div>
        <label className="block font-medium mb-1" htmlFor="name">
          Name
        </label>
        <input
          className="input input-bordered w-full p-2 rounded border border-gray-300"
          type="text"
          id="name"
          value={name}
          placeholder="Enter your name"
          required
          onChange={e => setName(e.target.value)}
        />
      </div>
      <div>
        <label className="block font-medium mb-1" htmlFor="email">
          Email
        </label>
        <input
          className="input input-bordered w-full p-2 rounded border border-gray-300"
          type="email"
          id="email"
          value={email}
          required
          placeholder="Enter your email"
          onChange={e => setEmail(e.target.value)}
          autoComplete="email"
        />
      </div>
      <Button type="submit" className="w-full" disabled={isSubmitting}>
        {isSubmitting ? "Saving..." : "Submit"}
      </Button>
    </form>
  );
};

export default OnboardingForm;
